import React, { useContext } from 'react';
import { Redirect, withRouter } from 'react-router-dom';

import { AuthContext } from '../contexts/auth';
import Splash from '../components/splash';

function SignupSuccess({ location }) {
	const { isAuthenticated } = useContext(AuthContext);

	return isAuthenticated ?
		<Redirect to={location.state?.from || '/me'} />
		:
		<Splash>
			<Splash.Body>
				<h3 className="text-center mb-3">Sign up to SignalStack</h3>

				<p>
					Thank you for the registration.<br/>
					Please, check for the confirmation email to continue.
				</p>
			</Splash.Body>
		</Splash>
	;
}

export default withRouter(SignupSuccess);
